import React, { CSSProperties } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { AppState } from "../../pages/main.reducer";
import { Currency } from "../../common/constants";
import { convertPrice, getCurrencyLabel } from "../../common/currencyUtils";

export const NumberMoney: React.FC<{
  value: number;
  minValue?: number;
  style?: CSSProperties;
  forceCurrency?: Currency;
}> = ({ value, minValue, style, forceCurrency }) => {
  const storeCurrency = useSelector<AppState, Currency>(store => store.common.currency);
  const conversionRate = useSelector<AppState, number>(store => store.common.conversionRate);
  const currency = forceCurrency ?? storeCurrency;

  const convertedValue = convertPrice(value, currency, conversionRate);
  const convertedMinValue = minValue ? convertPrice(minValue, currency, conversionRate) : undefined;
  const label = getCurrencyLabel(currency);
  // Always 2 decimals (para / feninga): Banca Intesa requires amounts in the smallest currency unit.
  const decimals = 2;

  const isRange = !!convertedMinValue && convertedMinValue < convertedValue;

  // A single price never breaks. A range ("1.700,00 - 1.900,00 RSD") may break after the dash,
  // so it fits narrow table columns on phones; each number stays in one piece.
  return (
    <span style={{ whiteSpace: isRange ? "normal" : "nowrap", ...style }}>
      {isRange && (
        <>
          <span style={{ whiteSpace: "nowrap" }}>
            <NumberFormat
              value={convertedMinValue}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={decimals}
              fixedDecimalScale={true}
            />
            {" -"}
          </span>{" "}
        </>
      )}
      <span style={{ whiteSpace: "nowrap" }}>
        <NumberFormat
          value={convertedValue}
          displayType="text"
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={decimals}
          fixedDecimalScale={true}
        />
        &nbsp;<sup style={{ fontSize: "70%" }}>{label}</sup>
      </span>
    </span>
  );
};

export const NumberDecimal: React.FC<{ value: number }> = ({ value }) => (
  <NumberFormat
    value={value}
    displayType="text"
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={2}
    fixedDecimalScale={true}
  />
);
